<div *ngIf="!disabled">
    <input type="file" name="inputUpload" id="inputUpload" class="upload" (change)="handleFileInput($event.target)" />
    <label for="inputUpload" *ngIf="!fileToUpload">
        <app-toolkit-bl-icon cssClass="icon icon-sm" icon="upload"></app-toolkit-bl-icon>
        <span>Seleziona il file...</span>
    </label>
</div>
<ul class="upload-file-list" *ngIf="fileName">
    <li class="upload-file success">
        <app-toolkit-bl-icon cssClass="icon icon-sm" icon="file"></app-toolkit-bl-icon>
        <p>
            <span class="sr-only">File caricato:</span>
            {{ fileName }} <span class="upload-file-weight">{{ fileToUpload ? ( (fileToUpload.size || 0) | convertFileSize) : '' }}</span>
        </p>
    </li>
</ul>
<button type="button" *ngIf="fileToUpload" class="btn btn-sm btn-outline-danger" (click)="reset()">
    <app-toolkit-bl-icon icon="close" cssClass="icon icon-sm icon-danger"></app-toolkit-bl-icon>
    Rimuovi file
</button>